module.exports = __webpack_public_path__ + "img/joia.68a6ff4b.jpg";